export const DEFAULT_MOOD = 'neutral';

/** Routine identity -> mood name used by [data-mood] in src/styles/moods.css */
export const ROUTINE_MOODS = {
  morning: 'morning',
  night: 'night',
  'post-exercise': 'active',
  'back-from-work': 'focus',
  'beach-day': 'sun',
  'after-night-out': 'nightout',
};

export const moodForRoutine = (routineType) => ROUTINE_MOODS[routineType] || 'custom';
